// No imports needed - error handling is set up at module level

// Store original console.error IMMEDIATELY when this module loads
const originalConsoleError = console.error;

// Patch console.error IMMEDIATELY to filter out harmless React portal cleanup errors
// This must happen before React starts rendering to catch errors during initial mount
console.error = (...args: any[]) => {
  // Check all arguments for removeChild/NotFoundError patterns
  const shouldFilter = args.some((arg: any) => {
    if (!arg) return false;

    const str = arg.toString();
    const message = arg?.message || "";
    const name = arg?.name || "";

    return (
      str.includes("removeChild") ||
      str.includes("NotFoundError") ||
      str.includes("The node to be removed is not a child") ||
      str.includes("The above error occurred") ||
      str.includes("Consider adding an error boundary") ||
      message.includes("removeChild") ||
      message.includes("NotFoundError") ||
      name === "NotFoundError"
    );
  });

  // If any argument matches our filter, silently ignore the entire log
  if (shouldFilter) {
    return;
  }

  // For all other errors, call the original console.error
  originalConsoleError.apply(console, args);
};

// Set up window error handler at module level to catch errors during initial render
window.addEventListener("error", (event: ErrorEvent) => {
  if (
    event.error?.message?.includes("removeChild") ||
    event.error?.message?.includes("NotFoundError") ||
    event.error?.message?.includes("The node to be removed is not a child")
  ) {
    // Prevent the error from being logged as "Uncaught"
    event.preventDefault();
    event.stopImmediatePropagation();
    return false;
  }
});

window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
  if (
    event.reason?.message?.includes("removeChild") ||
    event.reason?.message?.includes("NotFoundError")
  ) {
    // Prevent the promise rejection from being logged
    event.preventDefault();
    event.stopImmediatePropagation();
    return false;
  }
});

/**
 * Global error handler component that catches unhandled errors and promise rejections
 * throughout the wizard application. This helps prevent the app from crashing due to
 * React DOM errors like removeChild issues.
 *
 * Note: The actual error handling is done at module level (see above) to ensure
 * it's active before React even starts rendering.
 */
export function GlobalErrorHandler() {
  // Error handling is set up at module level, so this component just needs to exist
  // to ensure the module is loaded
  return null;
}
